import React, {useEffect, useState} from "react";
import {Table, TableCell, TableHead, TableBody, TableRow, Typography} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';

export const CallComparisonGrid = (props) => {
  const columns = [
    {field: 'id', headerName: "Station", width: 150},
    {field: 'current', headerName: "Zero Peaks Schedule", width: 200, align: "right"},
    {field: 'optimized', headerName: "New Schedule", width: 200, align: "right"},
    // {field: 'difference', headerName: "Difference", width: 200, align: "right"},
    {field: 'percentChange', headerName: "Percent Change", width: 200, align: "right"}
  ];

  const {data} = props;
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (data != null){
      preProcess(data);
    }
  }, [data]);

  const [sortModel, setSortModel] = useState([
    {
      field: 'difference',
      sort: 'asc',
    },
  ]);

  const preProcess = (data) => {
    let processed = [];
    let totalRow = {id: "Total", optimized: 0, current: 0};
    Object.keys(data).forEach(key => {
      // if (data[key].item1 === data[key].item2){
      //   return;
      // }
      let row = {id: key, optimized: data[key].item2, current: data[key].item1};
      row.difference = (row.optimized - row.current);
      row.percentChange = +((row.difference/row.current) * 100).toFixed(2);
      processed.push(row);
      totalRow.optimized += +(row.optimized);
      totalRow.current += +(row.current);
    });
    totalRow.percentChange = +(((totalRow.optimized - totalRow.current)/totalRow.current) * 100).toFixed(2);
    processed.push(totalRow);
    setRows(processed);
  }

  return (
    <div>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight
        density="compact"
        sortModel={sortModel}
        sortingOrder={['desc', 'asc']}
        onSortModelChange={(model) => setSortModel(model)}
      />
    </div>
  )
}

export const CallComparisonTable = (props) => {
  const {data} = props;

  

  return (
    <>
    {data && 
    <Table>
      <TableHead>
        <TableCell>
          Station
        </TableCell>
        <TableCell>
          Optimized Deployment
        </TableCell>
        <TableCell>
          Current Deployment
        </TableCell>
        <TableCell>
          Difference
        </TableCell>
        <TableCell>
          Percent Change
        </TableCell>
      </TableHead>

      <TableBody>
        {Object.keys(data).map(key => {
          if (data[key].item1 === data[key].item2){
            return;
          }
          return (
            <TableRow>
              <TableCell>
                {key}
              </TableCell>
              <TableCell sx={{textAlign: "right"}}>
                {data[key].item2}
              </TableCell>
              <TableCell>
                {data[key].item1}
              </TableCell>
              <TableCell>
                {data[key].item2 - data[key].item1}
              </TableCell>
              <TableCell>
                {+(100 * (data[key].item2 - data[key].item1)/(data[key].item1)).toFixed(2)}%
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
    }
  </>
  )

}